import regexConstants from 'constants/regex';
import dateTimeConstants from 'constants/datetime';
import moment from 'moment-timezone';

const {
  DATE_TIMEZONE,
  DATE_SLASH_FORMAT,
  DATEMIN_SLASH_FORMAT,
} = dateTimeConstants;

const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLocaleLowerCase();
};

const capitalJoin = (...args: Array<string>) => {
  return capitalize(args.join(' '));
};

const formatPrice = (price: number | string) => {
  return `${price}`.replace(regexConstants.PRICE_FORMAT, '.');
};

const formatTime = (time: number | undefined, format = DATE_SLASH_FORMAT) => {
  return moment(time)
    .tz(DATE_TIMEZONE)
    .format(format);
};

const formatDate = (time: number, format = DATEMIN_SLASH_FORMAT) => {
  return moment(time)
    .tz(DATE_TIMEZONE)
    .format(format);
};

const isPositiveNumber = (value: string) => {
  return /^\d+$/.test(value);
};

const isJsonString = (str: string) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export default {
  capitalize,
  capitalJoin,
  formatPrice,
  formatTime,
  formatDate,
  isPositiveNumber,
  isJsonString,
};
